import * as m from '~/paraglide/messages'
import { cn } from '~/shared/lib/utils'
import type { OpeningHour } from '~/shared/types/listing'
import { Disclosure } from '~/shared/ui/disclosure'

const DAYS_ORDER = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

const DAY_LABELS: Record<string, () => string> = {
  Sunday: m.sunday,
  Monday: m.monday,
  Tuesday: m.tuesday,
  Wednesday: m.wednesday,
  Thursday: m.thursday,
  Friday: m.friday,
  Saturday: m.saturday,
}

function formatTime(time: string) {
  const [hours, minutes] = time.split(':')
  return `${hours}:${minutes}`
}

function rangesOf(dayHours: OpeningHour[] | undefined): string {
  if (!dayHours || dayHours.length === 0) return m.closed()
  return dayHours.map((hour) => `${formatTime(hour.open)}–${formatTime(hour.close)}`).join(', ')
}

export function todayHoursLabel(hours: OpeningHour[]): string {
  const today = new Date().toLocaleDateString('en-US', { weekday: 'long' })
  return rangesOf(hours.filter((hour) => hour.day === today))
}

export function ListingHoursSummary({ hours }: { hours: OpeningHour[] }) {
  const today = new Date().toLocaleDateString('en-US', { weekday: 'long' })
  const byDay = new Map<string, OpeningHour[]>()
  for (const hour of hours) byDay.set(hour.day, [...(byDay.get(hour.day) ?? []), hour])

  return (
    <div className="space-y-1">
      <p>
        <span className="font-medium">{m.today()}</span>
        <span className="text-muted-foreground"> · {rangesOf(byDay.get(today))}</span>
      </p>
      <Disclosure title={m.openingHoursAll()}>
        <ul className="space-y-1">
          {DAYS_ORDER.map((day) => (
            <li
              key={day}
              className={cn(
                'flex items-center justify-between gap-4',
                day === today && 'font-medium text-brand-subtle-foreground',
              )}
            >
              <span>{DAY_LABELS[day]?.() ?? day}</span>
              <span className={cn('tabular-nums', !byDay.get(day) && 'text-muted-foreground')}>
                {rangesOf(byDay.get(day))}
              </span>
            </li>
          ))}
        </ul>
      </Disclosure>
    </div>
  )
}
